import { render, staticRenderFns } from "./deleteNotice.vue?vue&type=template&id=7f5e4360"
import script from "./deleteNotice.vue?vue&type=script&lang=js"
export * from "./deleteNotice.vue?vue&type=script&lang=js"
import style0 from "./deleteNotice.vue?vue&type=style&index=0&id=7f5e4360&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports